// extracted by mini-css-extract-plugin
export var chevron = "_lg-3";
export var chevronRotated = "_lg-4";
export var image = "_lg-1";
export var imageContainer = "_lg-0";
export var shippingAddress = "_lg-2";